import {Auth0Provider} from '@auth0/auth0-react'
import type {PropsWithChildren} from 'react'
import {useNavigate} from 'react-router-dom'
import {config} from '../../config.ts'

export const AuthProvider = ({children}: PropsWithChildren) => {
  const navigate = useNavigate()

  return (
    <Auth0Provider
      domain={config.auth0.domain}
      clientId={config.auth0.clientId}
      onRedirectCallback={(state) => {
        if (state?.returnTo) navigate(state?.returnTo)
      }}
      authorizationParams={{
        redirect_uri: window.location.origin,
        scope: 'profile email offline_access',
      }}
    >
      {children}
    </Auth0Provider>
  )
}
